import { useEffect as d, useCallback as l } from "react";
import { useSWRConfig as m } from "swr";
const n = /* @__PURE__ */ new Set(), i = (t) => JSON.stringify(typeof t == "function" ? t() : t), v = (t) => {
  const s = i(t);
  d(() => (n.add(s), () => {
    n.delete(s);
  }), [s]);
}, A = () => {
  const { mutate: t, cache: s } = m();
  return {
    revalidateModules: l(
      async (r, f = !1) => {
        const o = (e) => f || !n.has(i(e)), u = Array.from(s.keys());
        for (const e of u)
          typeof e == "string" && e.startsWith("$inf$") && r.some((a) => e.includes(a)) && await t(e);
        await t((e) => Array.isArray(e) ? e.some((a) => r.includes(a)) && o(e) : !1, void 0), await t((e) => Array.isArray(e) ? e.some((a) => r.includes(a)) && !o(e) : !1);
      },
      [s, t]
    )
  };
};
export {
  A as useRevalidateModules,
  v as useTrackedSWRKey
};
